/**
 * @desc 保存或更新
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderPackageDeliveryRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemOrderPackageDeliveryInformation/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
